import FilterRequest from '../../../../../Spirit/Common/Extensions/Models/FilterRequest';

export default class SearchLevelRequest extends FilterRequest {
	Name?: string = '';
	constructor(obj?: Partial<SearchLevelRequest>) {
		super(obj);
		if (obj) {
			Object.assign(this, obj);
		}
	}
}
